<!-- eslint-disable -->
<template>
  <div class="p2s1_main_container" :style="{ fontSize: DV_fontSize + 'px' }">
    <div class="p2s1_default_view" :class="{ G_hidden_element: activeModal !== 'default'}">
      
      <!-- if things initialized completely -->
      <div v-if="isInitiailized === true" class="p2s1_grid_container">
        
        <!-- If loading orgss and systems information show loading sigh -->
        <div v-if="C_isLoadingOrgsAndSys" class="p2s1_header" :class="{p2s1_loading_state: C_isLoadingOrgsAndSys}">
          <beat-loader :loading="C_isLoadingOrgsAndSys" :color="C_loaderColor" :height="'50px'" :width="'50px'"></beat-loader>
          <p v-html="C_loadingMessage"></p>
        </div>
        
        <!-- Show header containing buttons and search input -->
        <div v-else class="p2s1_header">
          <div class="p2s1_button_menu">
            
            <!-- Search input field -->
            <div class="p2s1_search_area">
              <i class="p2s1_search_icon fa fa-search"></i>
              <input ref="search" class="p2s1_input"  required @input="updateSearchQuery" placeholder="Search For Organization or System" type="text">
              <button class="p2s1_clear_search_icon p2s1_clear_btn" @click="clearSearch" value="X"></button>
            </div>

            <!-- Buttons for different operations -->
            <div class="p2s1_all_buttons">
              <button class="p2s1_button p2s1_button1" @click="expandAll"></button>
              <button class="p2s1_button p2s1_button2" @click="collapseAll"></button>
              <button class="p2s1_button p2s1_button3" v-if="showOnlyProblemModeActive === false" @click="ShowProblems"></button>
              <button class="p2s1_button p2s1_button4" v-if="showOnlyProblemModeActive" @click="clearProblemsView"></button>
              <button class="p2s1_button p2s1_font_size_button" @click="updateFontSize('increase')">
                T +
              </button>
              <button class="p2s1_button p2s1_font_size_button" @click="updateFontSize('decrease')">
                T -
              </button>
            </div>
          </div>

          <!-- Show number of org and systems user has access to -->
          <div>
            <p v-if="!C_isLoadingOrgsAndSys" class="p2s1_org_system_count">You have access to <b>{{C_totalOrganizationCount}}</b> Organizations and <b>{{C_totalSystemCount}}</b> Systems under this account.</p>
          </div>
        </div>

        <!-- Org and systems Tree menu -->
        <div class="p2s1_tree_menu_area">
          <c2-System-Org-Tree-Menu
            v-if="activePreset !== null && activePreset !== undefined && 
                  presetData !== null && presetData !== {} && 
                  presetData !== undefined && activePreset in presetData"
            :location="presetData[activePreset]"
            :depth="0" 
            :presetName="activePreset"
            :selectedItemKey="selectedItemKey"
            :expandCollapseCommand="expandCollapseAllCommand"
            :showOnlyProblemsCommand="showOnlyProblemsCommand"
            :searchQuery="searchQuery"
            :searchQueryRequestTimestamp="searchQueryRequestTimestamp"
            :activeOrgUid="activeOrgUid"
            :activeSysUid="activeSysUid"
            @pass-event-show-reporting="eventShowReporting"
            @pass-select-org="eventSelectOrg"
            @pass-select-system="eventSelectSys"
            @pass-event-edit-org="eventEditOrg"
            @pass-event-edit-sys="eventEditSys"
            @pass-event-show-doghouse="eventShowDoghouse"
            @pass-event-show-details="eventShowSystemDetails"
            @pass-event-unselect-selected-item="eventUnSelectItem"
            @set-selected-item-key="eventSetSelectedItemKey"
            @event-set-children-visible="eventSetChildrenVisible"
          ></c2-System-Org-Tree-Menu>
        </div>
      </div>
    </div>
      
    <!-- Other components for differen modals -->
    <c2m1-Edit-Org-Menu 
      v-if="activeModal === 'c2m1' &&
            activeOrgUid !== null && 
            activeOrgUid !== undefined"
      :orgUid="activeOrgUid"
      :isModal="true"
      :parentTitle="modalTitle"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :parentParams="params"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c2m1-Edit-Org-Menu>

    <c2m2-Edit-Sys-Menu 
      v-if="activeModal === 'c2m2' &&
            activeOrgUid !== null && activeOrgUid !== undefined &&
            activeSysUid !== null && activeSysUid !== undefined"
      :orgUid="activeOrgUid"
      :systemUid="activeSysUid"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :isModal="true"
      :parentParams="params"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c2m2-Edit-Sys-Menu>

    <c5-doghouse 
      v-if="activeModal === 'c5' &&
            activeOrgUid !== null && 
            activeOrgUid !== undefined"
      :orgUid="activeOrgUid"
      :systemUid="activeSysUid"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :isModal="true"
      :parentParams="params"
      :disableUrlHistory="true"
      :forceNormalView="DV_doghouseForceNormalView"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @show-doghouse-summary="eventShowDoghouseSummary"
      @reset-doghouse-force-normal-view="resetDoghouseForceNormalView"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c5-doghouse>

    <c2m4-sys-details 
      v-if="activeModal === 'c2m4' &&
            activeOrgUid !== null && activeOrgUid !== undefined &&
            activeSysUid !== null && activeSysUid !== undefined"
      :orgUid="activeOrgUid"
      :systemUid="activeSysUid"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :isModal="true"
      :parentParams="params"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c2m4-sys-details>

    <c2m9-system-reporting 
      v-if="activeModal === 'c2m9' &&
            activeOrgUid !== null && activeOrgUid !== undefined &&
            activeSysUid !== null && activeSysUid !== undefined"
      :orgUid="activeOrgUid"
      :systemUid="activeSysUid"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :isModal="true"
      :parentParams="params"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c2m9-system-reporting>

    <c2m10-org-reporting 
      v-if="activeModal === 'c2m10' &&
            activeOrgUid !== null && activeOrgUid !== undefined"
      :orgUid="activeOrgUid"
      :systemUid="activeSysUid"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :isModal="true"
      :parentParams="params"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c2m10-org-reporting>

    <c5m2-doghouse-summary
      v-if="activeModal === 'c5m2' &&
            activeOrgUid !== null && 
            activeOrgUid !== undefined"
      :orgUid="activeOrgUid"
      :subItemIndex="subItemIndex + 1"
      :subItemsList="subItemsList"
      :isModal="true"
      :parentParams="params"
      @clear-org-system-selection="resetActiveOrgAndSys"
      @event-force-show-doghouse-normal-view="eventForceShowDoghouseNormalView"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></c5m2-doghouse-summary>
  </div>
</template>

<script>
/* eslint-disable */
const c2m4SysDetails = () => import('./c2m4SysDetails')
const c5Doghouse = () => import('./c5Doghouse')
const c5m2DoghouseSummary = () => import('./c5m2DoghouseSummary')
const c2m2EditSysMenu = () => import('./c2m2EditSysMenu')
const c2m1EditOrgMenu = () => import('./c2m1EditOrgMenu')
const c2m9SystemReporting = () => import('./c2m9SystemReporting')
const c2m10OrgReporting = () => import('./c2m10OrgReporting')
import c2SystemOrgTreeMenu from "./c2SystemOrgTreeMenu";
import {bi10SubpageTemplate} from '../../../watchdog_includes/base_i10_UI_mixins'
import { setTimeout } from 'timers';
import AWN from "awesome-notifications"
import _ from 'lodash';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'

export default {
  name: "p2s1MyOrganizations",
  components: {
    c2m1EditOrgMenu,
    c2m2EditSysMenu,
    c5Doghouse,
    c2SystemOrgTreeMenu,
    c2m4SysDetails,
    BeatLoader,
    c2m9SystemReporting,
    c2m10OrgReporting,
    c5m2DoghouseSummary
  },
  mixins: [bi10SubpageTemplate],

  props: ["orgUid", "sysUid"],

  data() {
    return {
      activePreset: null,
      presetData: {},
      selectedItemKey: "",
      activeOrgUid: null,
      activeSysUid: null,
      expandCollapseAllCommand: null,
      showOnlyProblemsCommand: false,
      showOnlyProblemModeActive: false,
      defaultModal:"default",
      modalTitle:'',
      authenticated: false,
      isGuest: false,
      searchQuery: false,
      searchQueryRequestTimestamp: null,
      DV_orgCountAndLoading: {},
      DV_loadedOrgsCount: 0,
      DV_timeElapsed: 0,
      DV_fontSize: 16,
      DV_doghouseForceNormalView: false,
      DV_showDoghouseSummary: false
    };
  },
  mounted() {
    if (this.$store.state.fontSize !== null && this.$store.state.fontSize !== undefined) {
      this.DV_fontSize = this.$store.state.fontSize;
    }
  },
  methods: {
    waitWatchdogReadyCallback() {
      this.authenticated  = window.vue_instance.$root.$data.userInfo.authenticated;
      this.isGuest  = window.vue_instance.$root.$data.userInfo.isGuest;
      this.presetData = window.G_watchdog_data.IV_presets;
      this.activePreset = "all_preset";
      this.DV_orgCountAndLoading = window.vue_instance.$data.watchdog.orgCountAndLoading;
      window.G_redirectUrl = window.location.href;
      
      var parse_props =  [
        { prop_name: "orgUid", functions: [this.setActiveOrg] },
        { prop_name: "sysUid", functions: [this.setActiveSystem] },
      ];
      this.parseRouteParams(parse_props)
    },
    expandAll() {
      this.resetProblemView();
      this.resetActiveOrgAndSys();
      this.expandCollapseAllCommand = "E" + new Date().getTime().toString();
    },
    collapseAll() {
      this.resetProblemView();
      this.resetActiveOrgAndSys();
      this.expandCollapseAllCommand = "C" + new Date().getTime().toString();
    },

    eventSelectOrg(args) {
      this.selectedItemKey = args[0]; //args[0] is key
      this.clearActiveSystem();
      this.setActiveOrg(args[1]); //args[1] is org_uid
    },
    eventShowReporting(uid) {
      if (uid.indexOf('org_') !== -1) {
        this.clearActiveSystem();
        this.setActiveOrg(uid);
        this.showModal("c2m10");
      } else if (uid.indexOf('sys_') !== -1) {
        this.setActiveSystem(uid);
        this.showModal("c2m9");
      }
      // var report_url = ''
      // report_url += window.G_ajax_test_domain + '/console/data.html?location=' + system_uid
      // window.open(report_url);
    },

    eventSelectSys(args) {
      this.selectedItemKey = args[0]; //args[0] is key
      this.setActiveSystem(args[1]); //args[1] is system_id
    },
    eventEditOrg(org_uid) {
      this.clearActiveSystem();
      this.setActiveOrg(org_uid);
      this.showModal("c2m1");
    },
    eventEditSys(system_uid) {
      this.setActiveSystem(system_uid);
      this.showModal("c2m2");
    },
    eventShowDoghouseSummary() {
      this.showModal("c5m2");
    },
    eventForceShowDoghouseNormalView() {
      this.DV_doghouseForceNormalView = true;
      this.showModal("c5");
    },
    eventShowDoghouse(uid) {
      if (uid.indexOf("sys_") >= 0) {
        this.setActiveSystem(uid);
      } else if (uid.indexOf("org_") >= 0) {
        this.clearActiveSystem();
        this.setActiveOrg(uid);
      }

      this.showModal("c5");
    },
    eventShowSystemDetails(uid) {
      if (uid.indexOf("sys_") >= 0) {
        this.setActiveSystem(uid);
        this.showModal("c2m4");
      }
    },

    clearActiveSystem() {
      this.activeSysUid = null;
      this.params['2-obj'] = null;
      this.params['3-obj_atr'] = null;
      this.params['1-sys'] = null;
      this.updateParams();
    },
    setActiveOrg(org_uid,retry_count=0) {
      this.params['0-org'] = org_uid;
      this.updateParams();

      //// if they don't have access to this org ask them through pop-up
      if (org_uid in window.G_watchdog_data.IV_org_permissions === false) {
        if (retry_count >= 20) {
          // if user is signedin and not a guest show notificaion.
          if (this.authenticated && !this.isGuest) {
            this.$awn.warning("Sorry, But you don't have permission to access this organization. Redirecting to Dashboard.");
            setTimeout(() => {location.assign(window.location.origin + '/dashboard/p2s1~default~');}, 4000)
            return;
          } else {
            var popup_options = {
            labels: {
              confirm: "Sorry, But you don't have permission to access this organization. What you do want to do?",
              },
              modal: { okLabel: "Go To Login Page", cancelLabel: "Go To Guest Dashboard" },
              position: "center",
            };
            let popup = new AWN(popup_options);
            popup.confirm("", 
              function() {
                location.assign(window.location.origin + "/login" + "?redirect_to=" + window.G_redirectUrl.replace(window.location.origin, ""));
              },
              function() {
                location.assign(window.location.origin + '/dashboard/p2s1~default~');
              }
            );
            return;
          }
          return;
        }
        setTimeout(function() {this.setActiveOrg(org_uid,retry_count+1);}.bind(this),300);
        return;
      }
      ////</end> if they don't have access to this org ask them through pop-up
      
      this.activeOrgUid = org_uid;
    },
    setActiveSystem(system_uid) {
      //this has to be in an if statement or when the page parses params before all the watchdog data is there direct links will fail
      if (system_uid in window.G_watchdog_data.IV_system_org_joins) {
        this.setActiveOrg(window.G_watchdog_data.IV_system_org_joins[system_uid]);
      }
      this.activeSysUid = system_uid;
      this.params['2-obj'] = null;
      this.params['3-obj_atr'] = null;
      this.params['1-sys'] = system_uid;
      this.updateParams();
    },
    ShowProblems() {
      this.selectedItemKey = '';
      this.clearSearch();
      this.setProblemViewCommand(true);
    },
    clearProblemsView() {
      this.clearSearch();
      this.setProblemViewCommand(false);
    },
    clearSearch() {
      this.searchQuery = false;
      this.$refs.search.value = '';
      this.searchQueryRequestTimestamp = null;
      this.resetActiveOrgAndSys();
    },
    resetProblemView() {
      this.setProblemViewCommand(false);
    },
    updateSearchQuery: _.debounce(
      function(input) {        
        if(this.$refs.search.value === "") {
          this.searchQuery = false;
          this.searchQueryRequestTimestamp = null;
          return;
        }

        this.searchQuery = this.$refs.search.value;
        this.searchQueryRequestTimestamp = new Date().getTime();
      },
      500
    ),
    resetActiveOrgAndSys() {
      this.activeSysUid = null;
      this.activeOrgUid = null;
      this.selectedItemKey = null;
      this.params['3-obj_atr'] = null;
      this.params['2-obj'] = null;
      this.params['1-sys'] = null;
      this.params['0-org'] = null;
      this.updateParams();
    },
    setProblemViewCommand(value) {
      this.showOnlyProblemsCommand = value;
      setTimeout(
        function() {
          this.showOnlyProblemModeActive = value;
        }.bind(this),
        300
      );
    },
    startCounter() {
      if (this.C_isLoadingOrgsAndSys === false) {
        return;
      } else {
        this.DV_timeElapsed += 1;
        setTimeout(this.startCounter, 1000);
      }
    },
    updateFontSize(operation) {
      operation === 'increase' ? this.DV_fontSize++ : this.DV_fontSize--;
      this.$store.commit("updateFontSize", this.DV_fontSize);
    },
    eventUnSelectItem() {
      this.resetActiveOrgAndSys();
    },
    eventSetSelectedItemKey(key) {
      this.selectedItemKey = key;
      if (key === undefined || key === null) { return; }

      var VI = this;

      setTimeout(function() {
        VI.updateSearchQueryForUrlParams(key, 0);
      }, 200)
    },
    resetDoghouseForceNormalView() {
      this.DV_doghouseForceNormalView = false;
    },

    updateSearchQueryForUrlParams(key, retry_count=0) {
      if (retry_count > 20) {
        return;
      }

      var VI = this;
      if (key.toLowerCase().includes("org") && this.activeSysUid === null) {
        let org_meta_data = window.vue_instance.$data.watchdog.orgMetaData[this.activeOrgUid];
        
        if (org_meta_data === null || org_meta_data === undefined || !this.$refs.search) {
          setTimeout(function() {
            VI.updateSearchQueryForUrlParams(key, retry_count+1);
          }, 200)
          return
        };
        
        if ('name' in org_meta_data !== false) {
          this.searchQuery = org_meta_data['name'];
          this.$refs.search.value = org_meta_data['name'];
          this.searchQueryRequestTimestamp = new Date().getTime();
        } else {
          setTimeout(function() {
            VI.updateSearchQueryForUrlParams(key, retry_count+1);
          }, 200)
        }
      } else if (key.toLowerCase().includes("sys")) {
        let sys_meta_data = window.vue_instance.$data.watchdog.objectsMetaData[this.activeSysUid.replace("sys_", "obj_")];

        if (sys_meta_data === null || sys_meta_data === undefined || !this.$refs.search) {
          setTimeout(function() {
            VI.updateSearchQueryForUrlParams(key, retry_count+1);
          }, 200)
          return
        };
        
        if ('name' in sys_meta_data !== false) {
          this.searchQuery = sys_meta_data['name'];
          this.$refs.search.value = sys_meta_data['name'];
          this.searchQueryRequestTimestamp = new Date().getTime();
        } else {
          setTimeout(function() {
            VI.updateSearchQueryForUrlParams(key, retry_count+1);
          }, 200)
        }
      }
    }
  },
  computed: {
    C_loaderColor() {
      return window.G_brand_color;
    },
    C_loadingTime() {
      // approximate time to load 1 organization is 0.08 seconds.
      return Math.ceil(0.028 * this.DV_loadedOrgsCount);
    },
    C_totalOrganizationCount() {
      let user_org_permissions = window.vue_instance.$data.watchdog.orgPermissions;
      if (user_org_permissions !== null && 
          user_org_permissions !== undefined && 
          typeof user_org_permissions === 'object') {
        return Object.keys(user_org_permissions).length;
      }
      return "UnKnown";
    },
    C_totalSystemCount() {
      let sys_org_joins = window.vue_instance.$data.watchdog.orgSystemJoinsReverseLookup;
      if (sys_org_joins !== null && 
          sys_org_joins !== undefined && 
          typeof sys_org_joins === 'object') {
        return Object.keys(sys_org_joins).length;
      }
      return "UnKnown";
    },
    C_loadingMessage() {
      return `Please wait while we load organization's data completely. Loading <b>${this.DV_loadedOrgsCount}</b> organizations. This should take around <b>${this.C_loadingTime}</b> seconds. Time Elapsed: <b>${this.DV_timeElapsed}</b> seconds.`
    },
    C_isLoadingOrgsAndSys() {
      return this.DV_orgCountAndLoading['is_loading'] === true;
    }
  },
  watch: {
    DV_orgCountAndLoading: {
      handler(val) {
        if (this.DV_orgCountAndLoading['org_count'] !== undefined && this.DV_orgCountAndLoading['org_count'] !== null) {
          this.DV_loadedOrgsCount = this.DV_orgCountAndLoading['org_count'];
          this.startCounter()
        }
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s1MyOrganizations/p2s1MyOrganizations.vue